import * as React from 'react';
import { connect } from 'react-redux';
import { CreateSurveyProps } from '../../common/CreateSurveyProps';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import { QuestionTypeModel } from '../../models/questionType.model';
import { ApplicationState } from '../../store';
import * as CreateSurveyStore from '../../store/CreateSurvey';

class Summary extends React.Component<CreateSurveyProps> {

     render() {
        return(
            <React.Fragment>

            <SortableQuestionList
                    survey={this.props.survey}
                    sanitizeGropId={this.sanitizeGropId}
                    questionTypes={this.props.questionType}
                    disabled={this.props.survey.statusId === this.props.surveyStatusPublishedId}
                    handleGroupChange={this.props.QuestionChangeGroupAction}
                    StartQuestionEdit={this.props.StartQuestionEdit}
                    CopyQuestion={this.props.CopyQuestion}
                    DeleteQuestion={this.props.DeleteQuestion}
                    onSortEnd={this.onRowSortEnd}
                    />

            <div className="col-sm-12 mt-5">
                <button className="btn btn-primary" onClick={() => this.props.MoveNextStep(this.props.step -1 )}>Previous</button>
                <button className="btn btn-primary" onClick={() => this.props.MoveNextStep(undefined)}>Continue</button>
            </div>

        </React.Fragment>
        );
    }

    private onRowSortEnd = ({oldIndex, newIndex}: {oldIndex: number, newIndex: number}) => {

        this.props.MoveQuestion(oldIndex, newIndex);

    }

    sanitizeGropId(gropId: number | null) {
        return gropId ? gropId : 0;
    }
};

const SortableQuestionItem = SortableElement((props: any) => (
                <div className={props.cardBorder + " border-2 card mb-2"} key={props.i + 'q'}>
                    <p className='text-center text-muted text-secondary'>:::</p>
                    <div className="card-body">
                        <h5 className="card-title"><span className='form-label fw-bold'>{props.qItms.questionEn}{props.qItms.isMandatory ? <samp className="text-danger">&nbsp;*</samp> : ''}</span> ({props.questionType.name})</h5>
                        <p className="card-text text-muted"><span className='text-muted'></span>{props.qItms.placeholderEn}</p>
    
                        <div className='row'>
                            <div className='col'>
                                <div className="input-group">
                                    <span className="input-group-text" id="basic-addon1">Group</span>
                                    <select className='form-select'
                                        disabled={props.btnDisabled}
                                        onChange={(e) => props.handleGroupChange(props.i, isNaN(+e.target.value) ? null : +e.target.value )}
                                        value={props.qItms.groupId ? props.qItms.groupId : ''} >
                                            <option value={0}>[None]</option>
                                        {
                                            props.groups.map((item: any, index: number) => {
                                                return (<option value={item.groupId} key={item.groupId + 'grpOption'}>{item.groupHeadingEn || item.groupSubHeadingEn}</option>)
                                            })
                                        }
                                    </select>
                                </div>
                            </div>
                            <div className="col">
                                <button className='btn btn-primary float-end'
                                    disabled={props.btnDisabled}
                                    onClick={() => props.StartQuestionEdit(props.i)}
                                    >Edit</button>
                                <button className='btn btn-outline-warning float-end'
                                    disabled={props.btnDisabled}
                                    onClick={() => props.CopyQuestion(props.i)}
                                    >Copy</button>
                                <button className='btn btn-outline-danger float-end'
                                    disabled={props.btnDisabled}
                                    onClick={() => props.DeleteQuestion(props.i)}
                                    >Delete</button>
                            </div>
                        </div>
    
                    </div>
                </div>
));
  
  const SortableQuestionList = SortableContainer((props: any) => {

        const questions = props.survey.questions;
        const groups = props.survey.groups;
        let cardBorder = 'border-success';

        if (questions ) {

            if ( questions.length > 0 ) {

                let groupId: number = -99;
        
                const items = [];

                for (let i = 0; i < questions.length; i++) {

                    if (props.sanitizeGropId(questions[i].groupId) !== groupId) {

                        const group = groups.find((f: any) => f.groupId === props.sanitizeGropId(questions[i].groupId));

                        cardBorder = cardBorder === 'border-success' ? 'border-warning' : 'border-success';
                    }
        
                    items.push(
                        <SortableQuestionItem key={`question-${i}`}
                        qItms={questions[i]}
                        i={i}
                        cardBorder={cardBorder}
                        questionType={props.questionTypes.find((f: any) => f.id === questions[i].questionTypeId) || new QuestionTypeModel()}
                        groups={groups}
                        disabled={props.disabled}
                        btnDisabled={props.disabled}
                        index={i}
                        handleGroupChange={props.handleGroupChange}
                        StartQuestionEdit={props.StartQuestionEdit}
                        CopyQuestion={props.CopyQuestion}
                        DeleteQuestion={props.DeleteQuestion}
                        />
                    );
        
                    groupId = props.sanitizeGropId(questions[i].groupId);

                }
        
                return (
                    <div className='col-xs-12'>
                        {items}
                    </div>
                );

            }

        }

        return (
            <div>
                <p>
                    Please add question(s)
                </p>
            </div>
        );
                                            
  });
  
export default connect(
    (state: ApplicationState) => state.createSurveyStore,
    CreateSurveyStore.actionCreators
)(Summary as any);
